import { getUserGuideUrl } from '../helpers/Utils';

export const smartHomeMenu = {
  id: 'secondmenu',
  icon: 'iconsminds-cpu',
  label: 'menu.smart-home',
  to: '/app/smart-home',
  subs: [
    {
      icon: 'simple-icon-bulb',
      label: 'menu.devices',
      to: '/app/smart-home/devices',
    },
    {
      icon: 'simple-icon-key',
      label: 'menu.access-control',
      to: '/app/smart-home/access',
    },
    {
      icon: 'simple-icon-paper-plane',
      label: 'menu.events',
      to: '/app/smart-home/events',
    },
    {
      icon: 'simple-icon-settings',
      label: 'menu.home-settings',
      to: '/app/smart-home/home-settings',
    },
    {
      icon: 'iconsminds-library',
      label: 'menu.user-guide',
      to: getUserGuideUrl(),
      newWindow: true,
    }
   ],
 };

export const dashboardMenu = {
  id: 'dashboard',
  icon: 'iconsminds-digital-drawing',
  label: 'menu.dashboard',
  to: '/app/dashboard'
};

const data = [
   {
    id: 'tours',
    icon: 'iconsminds-footprint-2',
    label: 'menu.tours',
    to: '/app/tours',
  },
  {
    id: 'account',
    icon: 'iconsminds-male',
    label: 'menu.account',
    to: '/app/account',
  },
];
export default data;
